<template>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="5" lg="4" class="ma-auto">
          <v-card outlined :loading="loading">
            <div class="px-8 pt-6 pb-12">
              <v-card-title class="justify-center">No Access</v-card-title>
              <v-card-subtitle class="mb-5"></v-card-subtitle>
              <v-card-text>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  console.log('noaccess');
  export default {
    name: 'NoAccess',
    data: () => ({
      loading: false
    }),
    methods: {
      
    }
  }
  </script>
  
  <style></style>
  